import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.CustomIndexInvestmentEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.CustomIndexInvestmentList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.CustomIndexInvestmentCreate })));

export default { edit, list, create };
